import { render, staticRenderFns } from "./ProdutoCarrinhoBtnItj.vue?vue&type=template&id=d575cd1a&scoped=true"
import script from "./ProdutoCarrinhoBtnItj.vue?vue&type=script&lang=js"
export * from "./ProdutoCarrinhoBtnItj.vue?vue&type=script&lang=js"
import style0 from "./ProdutoCarrinhoBtnItj.vue?vue&type=style&index=0&id=d575cd1a&prod&lang=css"
import style1 from "./ProdutoCarrinhoBtnItj.vue?vue&type=style&index=1&id=d575cd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d575cd1a",
  null
  
)

export default component.exports